import styled from 'styled-components';

export const TvlApyValue = styled.span`
  font-weight: bold;
`;
